import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { RouterModule } from '@angular/router';

import { TranslateModule } from "@ngx-translate/core";
import { AddToSuccessModalComponentGeneric } from "./success-modal";
import {MatDialogModule} from '@angular/material/dialog';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        RouterModule,
        MatDialogModule
    ],
    exports: [AddToSuccessModalComponentGeneric],
    declarations: [AddToSuccessModalComponentGeneric]
})
export class SuccessModalModuleGeneric {}
